<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <h1 class="title is-5">{{ $t('resources.available') }}</h1>
        </div>
      </div>
      <div class="level">
        <div class="level-left">
          <div class="field controls is-grouped">
            <div class="control">
              <b-field :label="$t('interface.date')">
                <b-datepicker v-model="date"
                              @input="loadData"
                              :month-names="$locale.datePicker().month"
                              :day-names="$locale.datePicker().days"
                              icon="calendar-today">
                </b-datepicker>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <ResourcesCalendar :current-date="date"
                         :resources="list"
                         @reserve="reserve"
                         @remove-reservation="removeReservation">
      </ResourcesCalendar>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import ResourcesCalendar from '@/components/ResourcesCalendar'
  import {mapState} from 'vuex'
  import {prepareDate} from '@/utils'

  export default {
    components: {
      DashboardLayout,
      ResourcesCalendar
    },
    data() {
      return {
        date: new Date()
      }
    },
    methods: {
      loadData() {
        this.$store.dispatch('Resources/getList', prepareDate(this.date))
      },
      reserve({date, resourceId}) {
        this.$router.push({name: 'createReservation', params: {date: date.getTime(), resourceId}})
      },
      removeReservation({resourceId, reservationId}) {
        this.$store.dispatch('Resources/removeReservation', {resourceId, reservationId}).then(() => {
          this.loadData()
        })
      }
    },
    mounted() {
      this.loadData()
    },
    computed: {
      ...mapState('Resources', ['list']),
      breadcrumbs() {
        return [
          {name: 'resources'}
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>